import { render } from "./sidebar.html?vue&type=template&id=708ac9a8&external"
import script from "./sidebar.js?vue&type=script&lang=js&external"
export * from "./sidebar.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__